import React from 'react'
import PropTypes from 'prop-types'

import Play from 'app/components/SVGS/Play'
import Cross from 'app/components/SVGS/Cross'
import Repeat from 'app/components/SVGS/Repeat'

import './styles.scss'

const baseClass = 'activity-repeat-button'

class ActivityRepeatButton extends React.Component {
  static propTypes = {
    isActivityRepeating: PropTypes.bool.isRequired,
    setActivityRepeat: PropTypes.func.isRequired,
    activityId: PropTypes.number.isRequired,
  }

  state = {
    hovered: false,
  }

  onMouseEnterHandler = () => this.setState({ hovered: true })

  onMouseLeaveHandler = () => this.setState({ hovered: false })

  render() {
    const { t, isActivityRepeating, setActivityRepeat, activityId } = this.props
    const { hovered } = this.state
    if (isActivityRepeating) {
      return (
        <div
          className={`${baseClass}__repeating`}
          onClick={() => setActivityRepeat({ activityId, isRepeating: false })}
          onMouseEnter={this.onMouseEnterHandler}
          onMouseLeave={this.onMouseLeaveHandler}
        >
          <div className={`${baseClass}__repeating--title`}>{t(hovered ? 'Stop Repeating' : 'Repeating Activity')}</div>
          <div className={`${baseClass}__repeating--icon`}>
            {hovered ? <Cross pathProps={hovered ? { fill: '#ff8484' } : {}} /> : <Repeat />}
          </div>
        </div>
      )
    }
    return (
      <div className={baseClass} onClick={() => setActivityRepeat({ activityId, isRepeating: true })}>
        <div className={`${baseClass}__title`}>{t('Repeat Activity')}</div>
        <div className={`${baseClass}__icon`}>
          <Play width="7px" height="8px" />
        </div>
      </div>
    )
  }
}

export default ActivityRepeatButton
